__turbopack_context__.v({
  "banner-container": "_5hr4LG_banner-container",
  "banner-container-image": "_5hr4LG_banner-container-image",
  "banner-container-overview": "_5hr4LG_banner-container-overview",
  "button": "_5hr4LG_button",
  "content-container": "_5hr4LG_content-container",
  "content-container-items": "_5hr4LG_content-container-items",
  "content-container-items-caption": "_5hr4LG_content-container-items-caption",
  "content-container-items-circle": "_5hr4LG_content-container-items-circle",
  "form-comment": "_5hr4LG_form-comment",
  "form-counter": "_5hr4LG_form-counter",
  "form-input-counter": "_5hr4LG_form-input-counter",
  "title": "_5hr4LG_title",
  "wishlist-form-container": "_5hr4LG_wishlist-form-container",
});
